import React, { Component } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Link, withRouter } from "react-router-dom"; // Added withRouter
import api from "../service/ApiService";
import {
  getProfileListUrl,
  deleteProfileUrl,
  getDeviceSearchData,
} from "../service/ApiUrls";
import { Modal } from "react-bootstrap";
import { OSTypeEnum, ActionAssign, ActionCopyOREdit } from "../Enums";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Loader from "../components/Loader";
import Assign from "../components/Assign";
import DeleteProfile from "../components/DeleteProfile";
import { OverlayPanel } from "primereact/overlaypanel";
import { Tooltip } from "primereact/tooltip";
import { confirmAlert } from "react-confirm-alert";

const helpIcon = require("../assets/icons/help_icon.png");

class DeviceProfile extends Component {
  constructor() {
    super();
    this.state = {
      content: [], // Data for table
      editing: false,
      visible: false, // For loading dialog
      showModal: false, // For create modal
      playStoreType: 0,
      profileType: 0,
      currentPage: 1,
      drows: 20,
      dfirst: 0,
      divisionId: null,
      selectDivisionList: [],
      profileList: [], // For delete replacement
      filterData: "",
      textInLoader: "Loading...",
    };
    this.editorForRowEditing = this.editorForRowEditing.bind(this);
    this.onRowEditInit = this.onRowEditInit.bind(this);
  }

  componentDidMount() {
    this.initializeData();
  }

  // logic broken into sequence to avoid infinite loops
  initializeData = async () => {
    await this.callDeviceSearchData();
    // After divisionId is determined in the call above, fetch the list
    this.callProfileList();
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  onDialogueHide = () => {
    this.setState({ visible: false });
  };

  callgetProfileList = async ({
    first = 0,
    limit = 20,
    filter = null,
    divisionId = null,
  } = {}) => {
    return api
      .get(getProfileListUrl, {
        params: { first, limit, filter, divisionId },
      })
      .then((res) => {
        const { data, result: { isError, errMsg, statusCode } } = res.data;
        if (isError === false) return { data, result: { isError, errMsg, statusCode } };
      })
      .catch((err) => console.log("err", err));
  };

  callDeviceSearchData = async () => {
    try {
      const res = await api.get(getDeviceSearchData);
      if (res.data.result.isError === false) {
        const fetchedDivisions = res.data.data.divisionList;
        const accType = localStorage.getItem("accType");

        let initialDivisionId = this.state.divisionId;

        // Requirement: accType 0 is Admin -> No default selection (keep null)
        // Requirement: accType 1 is User -> Force the first division
        if (accType === "1" && fetchedDivisions.length > 0) {
          initialDivisionId = fetchedDivisions[0].id;
        }
        // For Admin (0), if we don't have a state value yet, keep it null so "Select Division" shows
        else if (accType === "0") {
          initialDivisionId = this.state.divisionId || null;
        }

        this.setState({
          profileList: res.data.data.profileList,
          selectDivisionList: fetchedDivisions,
          divisionId: initialDivisionId,
        });
      }
    } catch (err) {
      console.error("Search Data Fetch Error", err);
    }
  };

  callProfileList = async ({ filter = null, divisionId = null } = {}) => {
    const searchFilter = filter !== null ? filter : this.state.filterData;
    const selectedDivision = divisionId !== null ? divisionId : this.state.divisionId;

    this.setState({ visible: true, textInLoader: "Fetching Profiles..." }, async () => {
      let response = await this.callgetProfileList({
        first: this.state.dfirst / this.state.drows,
        limit: this.state.drows,
        filter: searchFilter,
        divisionId: selectedDivision,
      });

      if (response?.data) {
        this.setState({
          content: response.data.content,
          totalRecords: response.data.totalRecords,
          visible: false,
          divisionId: selectedDivision,
          filterData: searchFilter,
        });
      } else {
        this.setState({ visible: false, content: [] });
      }
    });
  };

  onPage = (event) => {
    const { first, rows, page } = event;
    this.setState(
      {
        dfirst: first,
        drows: rows,
        page,
        currentPage: page + 1,
      },
      () => {
        this.callProfileList();
      }
    );
  };

  onRowEditInit(event) {
    console.log("Edit Init", event);
  }

  onEditorValueChangeForRowEditing(props, value) {
    let updatedCars = [...props.value];
    updatedCars[props.rowIndex][props.field] = value;
    this.setState({ content: updatedCars });
  }

  editorForRowEditing(props, field) {
    return (
      <InputText
        type="text"
        value={props.rowData[field]}
        onChange={(e) => this.onEditorValueChangeForRowEditing(props, e.target.value)}
      />
    );
  }

  rowDelete = (rowData, column, replaceProfileId) => {
    this.setState({ visible: true, textInLoader: "Deleting Profile ...." }, () => {
      api
        .delete(deleteProfileUrl + "/" + rowData.id, {
          params: { replaceid: replaceProfileId.id },
        })
        .then((res) => {
          this.setState({ visible: false });
          if (res.data.result.isError === false) {
            confirmAlert({
              title: "Success Message",
              message: <p className="mod-sp">Deleted Profile Successfully</p>,
              buttons: [{ label: "Ok", onClick: () => this.callProfileList() }],
            });
          }
        })
        .catch(() => this.setState({ visible: false }));
    });
  };

  onBody = (rowData, column) => {
    const property = column.field;
    const getKeyByValue = (obj, value) =>
      Object.keys(obj).find((key) => obj[key] === value);
    return rowData.hasOwnProperty(property) && property === "osType"
      ? getKeyByValue(OSTypeEnum, rowData[property])
      : rowData[property];
  };

  actionTemplate(rowData, column) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        {/* standard tags used instead of Link to prevent PropType errors and history navigation crashes */}
        <span style={{ cursor: "pointer" }}>
          <Tooltip target=".pi-pencil" position="top" />
          <i
            className="pi pi-pencil mx-2"
            data-pr-tooltip="Edit"
            onClick={() =>
              this.props.history.push({
                pathname: "/device-profile",
                state: { e: rowData, from: ActionCopyOREdit.EDIT },
              })
            }
          />
        </span>

        <span style={{ cursor: "pointer" }}>
          <Tooltip target=".pi-copy" position="top" />
          <i
            className="pi pi-copy mx-2"
            data-pr-tooltip="Copy"
            onClick={() =>
              this.props.history.push({
                pathname: "/device-profile",
                state: { e: rowData, from: ActionCopyOREdit.COPY },
              })
            }
          />
        </span>

        <DeleteProfile
          rowData={rowData}
          searchData={this.state.profileList}
          parentDelete={this.rowDelete}
        />

        <Assign
          showIcon={true}
          name={"Device Profile Assign: " + rowData.name}
          dataToSend={rowData}
          fromModule="profile"
          actionType={ActionAssign.ASSIGN}
        />
      </div>
    );
  }

  render() {
    const items = [
      { label: "Dashboard", url: "dashboard" },
      { label: "Device Outline", url: "device-outline" },
      { label: "Device Profile List" },
    ];
    const home = { icon: "pi pi-home", url: "dashboard" };

    const header = (
      <div className="row justify-content-end align-items-center">
        <div className="p-col-12 p-md-3 p-lg-3">
          <h2 style={{ textAlign: "left", margin: 0 }}>Device Profile List</h2>
        </div>
        <div className="p-col-12 p-md-3 p-lg-3">
          <div className="form-group mb-0">
            <select
              className="form-control"
              value={this.state.divisionId || ""}
              onChange={(e) => {
                const val = e.target.value;
                this.setState({ divisionId: val }, () => {
                  this.callProfileList({ divisionId: val });
                });
              }}
              disabled={localStorage.getItem("accType") === "1"}
            >
              <option value="">Select Division</option>
              {this.state.selectDivisionList.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="p-col-12 p-md-4 p-lg-4">
          <div className="p-inputgroup flex-1">
            <InputText
              placeholder="Enter Search Item"
              value={this.state.filterData}
              onChange={(e) => {
                const val = e.target.value;
                this.setState({ filterData: val }, () => {
                  if (val.length === 0) this.callProfileList({ filter: "" });
                });
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) this.callProfileList();
              }}
            />
            <Button
              icon="pi pi-search"
              onClick={() => this.callProfileList()}
              className="p-button-primary"
            />
          </div>
        </div>
        <div className="p-col-12 p-md-2 p-lg-2 text-end">
          <Button
            label="Add New"
            icon="pi pi-plus"
            className="p-button-primary"
            onClick={() =>
              this.props.history.push({
                pathname: "/device-profile",
                state: {
                  profileType1: 1,
                  playstoreMode1: 0,
                },
              })
            }
          // onClick={() => this.setState({ showModal: true })}
          />
        </div>
      </div>
    );

    return (
      <div className="p-col-12 p-grid">
        <Dialog
          visible={this.state.visible}
          modal
          showHeader={false}
          closable={false}
          style={{ width: "20vw" }}
          onHide={this.onDialogueHide}
        >
          <Loader textToShow={this.state.textInLoader} />
        </Dialog>

        <div className="p-col-12 p-lg-12 p-ll">
          <div className="p-grid align-items-center">
            <div className="p-col-11">
              <BreadCrumb model={items} home={home} />
            </div>
            <div className="p-col-1">
              <img
                src={helpIcon}
                width="20"
                height="20"
                onClick={(e) => this.op.toggle(e)}
                style={{ float: "right", cursor: "pointer" }}
                alt="help"
              />
            </div>
          </div>

          <OverlayPanel ref={(el) => (this.op = el)} id="overlay_panel" showCloseIcon>
            <div className="col" style={{ maxWidth: "300px", padding: "0px" }}>
              <div className="helptip-title">
                <b>How to : Device Profile</b>
              </div>
              <div className="helptip-des">
                A device profile represents policies for managed devices. Create a profile and
                apply it to multiple devices at once.
              </div>
            </div>
          </OverlayPanel>
        </div>

        <div className="p-grid bg-col p-lg-12 datatable-paginator-demo">
          <DataTable
            ref={(el) => (this.dt = el)}
            value={this.state.content}
            header={header}
            paginator
            lazy
            rows={this.state.drows}
            totalRecords={this.state.totalRecords}
            first={this.state.dfirst}
            onPage={this.onPage}
            emptyMessage="No records found"
            className="p-datatable-sm"
          >
            <Column field="name" header="Name" sortable />
            <Column field="osType" header="Os Type" body={this.onBody} textAlign="center" />
            <Column field="countAssignedDevice" header="Devices" textAlign="center" />
            <Column field="divisionName" header="Division Name" textAlign="center" />
            <Column field="countAllowedApp" header="Allowed Apps" textAlign="center" />
            <Column header="Action" body={this.actionTemplate.bind(this)} textAlign="center" />
          </DataTable>
        </div>

        <Modal show={this.state.showModal} onHide={this.handleClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "16px", fontWeight: "bold" }}>
              Create Device Profile
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-md-12">
              <p>1. Select Profile Type</p>
              <div className="d-flex gap-3 mb-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="pType"
                    id="fm"
                    checked={this.state.profileType === 0}
                    onChange={() => this.setState({ profileType: 0 })}
                  />
                  <label className="form-check-label" htmlFor="fm">Fully Managed</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="pType"
                    id="byod"
                    checked={this.state.profileType === 1}
                    onChange={() => this.setState({ profileType: 1 })}
                  />
                  <label className="form-check-label" htmlFor="byod">BYOD</label>
                </div>
              </div>
              <p>2. Select Playstore Mode</p>
              <div className="d-flex gap-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="psMode"
                    id="wl"
                    checked={this.state.playStoreType === 0}
                    onChange={() => this.setState({ playStoreType: 0 })}
                  />
                  <label className="form-check-label" htmlFor="wl">Whitelist</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="psMode"
                    id="bl"
                    checked={this.state.playStoreType === 1}
                    onChange={() => this.setState({ playStoreType: 1 })}
                  />
                  <label className="form-check-label" htmlFor="bl">Blocklist</label>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              label="Submit"
              onClick={() =>
                this.props.history.push({
                  pathname: "/device-profile",
                  state: {
                    profileType1: this.state.profileType,
                    playstoreMode1: this.state.playStoreType,
                  },
                })
              }
            />
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(DeviceProfile);